// PARA-136 — маппинг ошибки PATCH /users/me/settings в ошибки формы.

import { ApiError } from '../../../api/client';
import type { EveningReminderFormErrors } from '../types';

interface ValidationDetail {
  loc: string[];
  msg: string;
}

/** Превращает ApiError 422 в полевые/общие ошибки формы. Прочие ошибки — общие. */
export function mapUpdateError(error: Error | null): EveningReminderFormErrors | undefined {
  if (error === null) {
    return undefined;
  }
  if (!(error instanceof ApiError)) {
    return { general: 'errors.saveFailed' };
  }
  if (error.status !== 422) {
    return { general: 'errors.saveFailed' };
  }
  const body = error.body as { detail?: ValidationDetail[] } | undefined;
  const errors: EveningReminderFormErrors = {};
  let hasFieldError = false;
  for (const item of body?.detail ?? []) {
    const field = item.loc.at(-1);
    if (field === 'evening_reminder_time') {
      errors.evening_reminder_time = item.msg;
      hasFieldError = true;
    } else if (field === 'evening_reminder_timezone') {
      errors.evening_reminder_timezone = item.msg;
      hasFieldError = true;
    }
  }
  if (!hasFieldError) {
    errors.general = 'errors.saveFailed';
  }
  return errors;
}
